module.exports = __webpack_public_path__ + "media/กูรู้คนมันเกลียดกู_มันไม่ชอบกู.59d5bae5.mp3";